import { action, observable } from 'mobx';
import _ from 'lodash';
import moment from 'moment';
import states from '../../../../data/states.json';
import Practioner from './Practitioner';


class QualityStore {

  @observable currentDate = new Date().toJSON().split('T')[0];

  @observable blocking = false;

  @observable states = [];
  @observable orgField = false;
  @observable openModal = false;
  @observable errorCount = 0;

  // State Code
  @observable stateCode = '';

  // Preparer Information
  @observable firstName = '';
  @observable lastName = '';
  @observable preparerOrg = '';
  @observable department = '';
  @observable jobTitle = '';
  @observable repPhone = '';
  @observable dateOfReport = new Date().toISOString().split("T")[0];
  @observable datetoDisplay = `${(new Date().getMonth() + 1 < 10 ? '0' : '')}${new Date().getMonth() + 1}/${(new Date().getDate() < 10 ? '0' : '')}${new Date().getDate()}/${new Date().getFullYear()}`;
  @observable extension = '';
  @observable displayPhone = '';

  // Organization Information
  @observable selectedOrg = '';
  @observable selectProv = '';
  @observable taxId = '';
  @observable taxIds = [];
  @observable customerId = '';
  @observable npi = '';

  // Member Information
  @observable member = {
    memberFirst: '',
    memberLast: '',
    memberInitial: '',
    memDOB: '',
    isMemberMinor: '',
    subscriberId: '',
    memStreetSuite: '',
    memcity: '',
    memState: '',
    memZip: '',
    memPhone: '',
    memPhoneType: ''
  }

  @observable pg = {
    pgFirstName: '',
    pgLastName: '',
    pgMiddleInitial: '',
    pgRelation: ''
  }

  @observable authRep = {
    authRepFirstName: '',
    authRepLastName: '',
    authRepMiddleInitial: '',
    authRelation: ''
  }

  // Practioner & Location
  @observable practitioner = {
    practFirst: '',
    practLast: '',
    pracNPI: ''
  }

  @observable practitionerList = [];

  @observable location = {
    name: '',
    streetSuite: '',
    city: '',
    state: '',
    zip: '',
    contactFirst: '',
    contactLast: '',
    contactPhoneExt: ''
  }

  // Incident Details

  @observable comparator = false;

  @observable incidentCategories = [];

  @observable incident = {
    incidentRepeat: '',
    incidentStart: '',
    incidentEnd: '',
    additionalDetails: ''
  }

  @observable physOrBehavior = '';

  @observable memHospitalized = '';

  @observable originalAdmission = '';
  @observable dischargeDate = '';

  @observable memReadmitted = '';

  @observable readmissionDate = '';
  @observable readmissDischargeDate = '';

  @observable testFormData = {
    "application": "Public",
    "market": "NE",
    "planName": "NE test",
    "extReqId": "123",
    "incidentDate": "10/10/2020",
    "dateReceived": "10/15/2020",
    "incidentRecordNumber": "",
    "requestType": "QOC",
    "lob": "GBD",
    "questions": [
      {
        "questionID": "Q1",
        "questionCategory": "QOC Information",
        "answerID": [
          "Q1A4"
        ]
      },
      {
        "questionID": "Q2",
        "questionCategory": "QOC Information",
        "answerID": [
          "Q2A1"
        ]
      },
      {
        "questionID": "Q3",
        "questionCategory": "QOC Information",
        "answerID": [
          "Q3A1-Other-2020-11-04"
        ]
      },
      {
        "questionID": "Q4",
        "questionCategory": "QOC Information",
        "answerID": [
        ]
      },
      {
        "questionID": "Q5",
        "questionCategory": "QOC Information",
        "answerID": [
        ]
      },
      {
        "questionID": "Q6",
        "questionCategory": "QOC Information",
        "answerID": [
          "Q6A2"
        ]
      },
      {
        "questionID": "Q7",
        "questionCategory": "QOC Information",
        "answerID": [
          "Q7A1-Other-2020-11-01"
        ]
      },
      {
        "questionID": "Q8",
        "questionCategory": "QOC Information",
        "answerID": [
          "Q8A1-Other-2020-11-03"
        ]
      },
      {
        "questionID": "Q9",
        "questionCategory": "QOC Information",
        "answerID": [
          "Q9A1"
        ]
      },
      {
        "questionID": "Q10",
        "questionCategory": "QOC Information",
        "answerID": [
          "Q10A1-Other-2020-11-02"
        ]
      },
      {
        "questionID": "Q11",
        "questionCategory": "QOC Information",
        "answerID": [
          "Q11A1-Other-2020-11-03"
        ]
      },
      {
        "questionID": "Q12",
        "questionCategory": "QOC Information",
        "answerID": [
          "Q12A1-Other-Nothing really"
        ]
      },
      {
        "questionID": "Q13",
        "questionCategory": "QOC Information",
        "answerID": [
          "Q13A1"
        ]
      }
    ],
    "submitterData": {
      "avUserId": "",
      "userFirstName": "Praveen",
      "userLastName": "Lavu",
      "dateReported": "10/15/2020",
      "organization": "Anthem",
      "departmentName": "GnA",
      "jobTitle": "ES",
      "phone": "1234567890",
      "TIN": "",
      "NPI": ""
    },
    "provider": {
      "name": "Praveen L",
      "ID": "123",
      "NPI": "",
      "TIN": "",
      "groupName": "",
      "planId": "",
      "officeContactPerson": "",
      "locationContactFirstName": "Dev",
      "locationContactLastName": "Ved",
      "phone": "",
      "address": {
        "addrLine1": "",
        "addrLine2": "",
        "city": "",
        "state": "",
        "zip": "",
        "county": "",
        "phoneNumber": "4703463177",
        "faxNumber": "",
        "email": "",
        "prefMOC": ""
      }
    },
    "practitionerForQOC": [
      {
        "pracFirstName": "",
        "pracLastName": "",
        "pracNPI": ""
      }
    ],
    "member": {
      "ID": "678987890",
      "medicaidID": "",
      "lob": "mma medicaid",
      "firstName": "JANE",
      "lastName": "DOE",
      "name": "",
      "middleInitial": "",
      "sex": "FEMALE",
      "dateOfBirth": "10/10/2000",
      "isMemberMinor": "",
      "parentGuardianFirstName": "",
      "parentGuardianMiddleInitial": "",
      "parentGuardianLastName": "",
      "parentGuardianRelation": "",
      "policyState": "",
      "authRepFirstName": "",
      "authRepMiddleInitial": "",
      "authRepLastName": "",
      "authRepRelation": "",
      "address": {
        "addrLine1": "123 PEACHTREE ST",
        "addrLine2": "",
        "city": "LUTZ",
        "state": "FL",
        "zip": "33606",
        "county": "PINNEALES",
        "phoneNumber": "4703463177",
        "phoneType": ""
      }

    }
  }

  @observable incidentFormData = {
    application: 'Public',
    market: '',
    planName: '',
    requestType: 'QOC',
    lob: '',
    extReqId: '',
    incidentDate: '',
    dateReceived: this.changeDateFormat(this.currentDate),
    incidentRecordNumber: '',
    questions: [],
    submitterData: {
      avUserId: '',
      userFirstName: '',    // Reporter/Preparer First Name
      userLastName: '',     // Reporter/Preparer Last Name
      createDateTime: this.changeDateFormat(this.currentDate),
      dateReported: '',
      organization: '',
      departmentName: '',
      jobTitle: '',
      phone: '',
      TIN: '',              // Optional
      NPI: ''               // Optional
    },
    provider: {
      name: '',
      ID: '',
      NPI: '',
      TIN: '',
      groupName: '',
      planId: '',
      officeContactPerson: '',
      locationContactFirstName: '',
      locationContactLastName: '',
      phone: '',
      address: {
        addrLine1: '',
        addrLine2: '',
        city: '',
        state: '',
        zip: '',
        county: '',
        phoneNumber: '',
        faxNumber: '',
        email: '',
        prefMOC: ''
      }
    },
    practitionerForQOC: [
      {
        pracFirstName: '',
        pracLastName: '',
        pracNPI: ''
      }
    ],
    member: {
      ID: '',             // Member or Medicaid ID
      medicaidID: '',
      lob: '',
      firstName: '',
      lastName: '',
      name: '',
      middleInitial: '',
      sex: '',
      dateOfBirth: '',
      isMemberMinor: '',
      parentGuardianFirstName: '',
      parentGuardianMiddleInitial: '',
      parentGuardianLastName: '',
      parentGuardianRelation: '',
      policyState: '',
      authRepFirstName: '',
      authRepMiddleInitial: '',
      authRepLastName: '',
      authRepRelation: '',
      address: {
        addrLine1: '',
        addrLine2: '',
        city: '',
        state: '',
        zip: '',
        county: '',
        phoneNumber: '',
        phoneType: ''
      }
    }
  }

  // Review and Submit
  @observable editReporter = false;
  @observable editMember = false;
  @observable editFacility = false;
  @observable editIncident = false;

  // Confirmation
  @observable submitSuccess = false;

  @observable confirmationId;

  constructor() {
    this.states = states;
  }

  // format date to mm/dd/yyyy format when user submit form from different browsers such as IE, Chrome.
  @action changeDateFormat(date) {
    if (date && (/^\d{4}-\d\d-\d\d$/.test(date) || /^\d\d\/\d\d\/\d{4}$/.test(date))) {
      // if it's a valid date
      if (date.indexOf('-') > -1) {
        // it's in yyyy-mm-dd format
        const [year, month, day] = date.split('-');
        return `${month}/${day}/${year}`;
      }
      if (date.indexOf('/') > -1) {
        // it's in mm-dd-yyyy format
        const [month, day, year] = date.split('/');
        return `${month}/${day}/${year}`;
      }
      return date;
    }
    // else it's not a valid date... not sure what you want to do.
    return date;
  }

  /* Progress Bar */
  @observable pages = [
    { title: 'Preparer Information', state: 'stepwizard-step active', href: '#preparerinfo', key: 0 },
    { title: 'Member Information', state: 'stepwizard-step disabled', href: '#memberinfo', key: 1 },
    { title: 'Provider & Location', state: 'stepwizard-step disabled', href: '#practitionerlocation', key: 2 },
    { title: 'Incident Details', state: 'stepwizard-step disabled', href: '#incidentdetails', key: 3 },
    { title: 'Review & Submit', state: 'stepwizard-step disabled', href: '#reviewsubmit', key: 4 }
  ];

  @action setPageStatus(pageKey, pageState) {
    const page = _.find(this.pages, page => page.href === pageKey);
    const pageStateString = `stepwizard-step ${pageState}`;
    page.state = pageStateString;
  }

  @action getPageStatus(pageKey) {
    const page = _.find(this.pages, page => page.href === pageKey);
    return page.state;
  }

  @action disablePages() {
    this.setPageStatus('#memberinfo', 'disabled');
    this.setPageStatus('#practitionerlocation', 'disabled');
    this.setPageStatus('#incidentdetails', 'disabled');
    this.setPageStatus('#reviewsubmit', 'disabled');
  }

  /* Progress Bar */

  @action setOpenModal() {
    this.openModal = !this.openModal;
  }

  @action incrementErrorCount() {
    this.errorCount = (this.errorCount + 1 === 3) ? 0 : this.errorCount + 1;
  }

  @action resetErrorCount() {
    this.errorCount = 0;
  }

  @action setOrgField() {
    this.orgField = !this.orgField;
  }

  @action clearIncidentForm() {
    // Landing page	or Preparer Information	
    this.firstName = '';
    this.lastName = '';
    this.preparerOrg = '';
    this.department = '';
    this.jobTitle = '';
    this.repPhone = '';
    this.extension = '';
    this.displayPhone = '';

    // Member Information	
    this.member = {
      memberFirst: '',
      memberLast: '',
      memberInitial: '',
      memDOB: '',
      isMemberMinor: '',
      subscriberId: '',
      memStreetSuite: '',
      memcity: '',
      memState: '',
      memZip: '',
      memPhone: '',
      memPhoneType: ''
    }
    this.pg = {
      pgFirstName: '',
      pgLastName: '',
      pgMiddleInitial: '',
      pgRelation: ''
    }
    this.authRep = {
      authRepFirstName: '',
      authRepLastName: '',
      authRepMiddleInitial: '',
      authRelation: ''
    }

    // Practioner & Location	
    this.practitioner = {
      practFirst: '',
      practLast: '',
      pracNPI: ''
    }
    this.practitionerList = [];
    this.location = {
      name: '',
      streetSuite: '',
      city: '',
      state: '',
      zip: '',
      contactFirst: '',
      contactLast: '',
      contactPhoneExt: ''
    }

    // Incident Details	
    this.comparator = false;
    this.incidentCategories = [];
    this.incident = {
      incidentRepeat: '',
      incidentStart: '',
      incidentEnd: '',
      additionalDetails: ''
    }
    this.physOrBehavior = '';
    this.memHospitalized = '';
    this.originalAdmission = '';
    this.dischargeDate = '';
    this.memReadmitted = '';
    this.readmissionDate = '';
    this.readmissDischargeDate = '';
    this.incidentFormData = {
      application: 'Public',
      market: '',
      requestType: 'QOC',
      lob: '',
      extReqId: '',
      incidentDate: '',
      dateReceived: this.changeDateFormat(this.currentDate),
      incidentRecordNumber: '',
      questions: [],
      submitterData: {
        avUserId: '',
        userFirstName: '',    // Reporter/Preparer First Name	
        userLastName: '',     // Reporter/Preparer Last Name	
        dateReported: '',
        organization: '',
        departmentName: '',
        jobTitle: '',
        phone: '',
        TIN: '',              // Optional	
        NPI: ''               // Optional	
      },
      provider: {
        name: '',
        ID: '',
        NPI: '',
        TIN: '',
        groupName: '',
        planId: '',
        officeContactPerson: '',
        locationContactFirstName: '',
        locationContactLastName: '',
        phone: '',
        address: {
          addrLine1: '',
          addrLine2: '',
          city: '',
          state: '',
          zip: '',
          county: '',
          phoneNumber: '',
          faxNumber: '',
          email: '',
          prefMOC: ''
        }
      },
      practitionerForQOC: [
        {
          pracFirstName: '',
          pracLastName: '',
          pracNPI: ''
        }
      ],
      member: {
        ID: '',             // Member or Medicaid ID	
        medicaidID: '',
        lob: '',
        firstName: '',
        lastName: '',
        name: '',
        middleInitial: '',
        sex: '',
        dateOfBirth: '',
        isMemberMinor: '',
        parentGuardianFirstName: '',
        parentGuardianMiddleInitial: '',
        parentGuardianLastName: '',
        parentGuardianRelation: '',
        policyState: '',
        authRepFirstName: '',
        authRepMiddleInitial: '',
        authRepLastName: '',
        authRepRelation: '',
        address: {
          addrLine1: '',
          addrLine2: '',
          city: '',
          state: '',
          zip: '',
          county: '',
          phoneNumber: '',
          phoneType: ''
        }
      }
    };
  }

  /* State Code */
  @action updateStateCode(stateCode) {
    this.stateCode = stateCode;
  }
  /* State Code */

  /* Preparer Info */
  @action updateRepFirst(first) {
    this.firstName = first;
  }

  @action updateRepLast(last) {
    this.lastName = last;
  }

  @action updateRepOrg(org) {
    this.preparerOrg = org;
  }

  @action updateRepDept(dept) {
    this.department = dept;
  }

  @action updateRepJobTitle(title) {
    this.jobTitle = title;
  }

  @action updateRepPhone(phone) {
    this.displayPhone = phone;
    const [repPhone, ext] = this.displayPhone.split("-");
    this.repPhone = repPhone;
    this.extension = ext;
  }
  /* Preparer Info */

  /* Member Info */
  @action updateMemberFirst(first) {
    this.member.memberFirst = first;
  }

  @action updateMemberLast(last) {
    this.member.memberLast = last;
  }

  @action updateMemberInitial(init) {
    this.member.memberInitial = init;
  }

  @action dateValueSetter(value) {
    if (value && /^\d{8}$/.test(value)) {
      const month = value.slice(0, 2);
      const day = value.slice(2, 4);
      const year = value.slice(4);

      value = `${month}/${day}/${year}`;
    }
    this.member.memDOB = value;

    const today = new Date();
    const DOB = new Date(this.member.memDOB);

    this.member.isMemberMinor = ((today.getFullYear() - DOB.getFullYear()) > 17) ? 'No' : 'Yes'
  }

  @action updateMemberSubscriberId(subscriberId) {
    this.member.subscriberId = subscriberId;
  }

  @action updateMemberStreetSuite(street) {
    this.member.memStreetSuite = street;
  }

  @action updateMemberCity(city) {
    this.member.memCity = city;
  }

  validateMemberCity() {
    if (/^\W+$/.test(this.member.memCity)) {
      return true;
    }
    return false;
  }

  @action updateMemState(state) {
    this.member.memState = state;
  }

  @action updateMemZip(zip) {
    this.member.memZip = zip;
  }

  @action updateMemPhone(phone) {
    this.member.memPhone = phone;
  }

  @action updatePhoneType(value) {
    this.member.memPhoneType = value;
  }

  @action updatePGFirstName(value) {
    this.pg.pgFirstName = value;
  }

  @action updatePGLastName(value) {
    this.pg.pgLastName = value;
  }

  @action updatePGMiddleInitial(value) {
    this.pg.pgMiddleInitial = value;
  }

  @action updatePGRelation(value) {
    this.pg.pgRelation = value;
  }

  @action updateAuthRepFirstName(value) {
    this.authRep.authRepFirstName = value;
  }

  @action updateAuthRepLastName(value) {
    this.authRep.authRepLastName = value;
  }

  @action updateAuthRepMiddleInitial(value) {
    this.authRep.authRepMiddleInitial = value;
  }

  @action updateAuthRepRelation(value) {
    this.authRep.authRelation = value;
  }
  /* Member Info */

  /* Practioner & Location */
  // Practioner Information //
  @action updatePractFirst(value) {
    this.practitioner.practFirst = value;
  }

  @action updatePractLast(value) {
    this.practitioner.practLast = value;
  }

  @action updatePractNPI(value) {
    this.practitioner.pracNPI = value;
  }

  @action addPractitioner() {
    const prac = {
      practFirst: '',
      practLast: '',
      pracNPI: ''
    }

    this.practitionerList.push(prac);
  }

  @action removePractitioner(index) {
    const filteredPractitionerList = this.practitionerList.filter((prac, sIndex) => index !== sIndex);
    this.practitionerList = filteredPractitionerList;
  }

  @action setPractitionerFirst(index, value) {
    this.practitionerList[index].practFirst = value;
  }

  @action setPractitionerLast(index, value) {
    this.practitionerList[index].practLast = value;
  }

  @action setPractitionerNPI(index, value) {
    this.practitionerList[index].pracNPI = value;
  }
  // Practitioner Information //

  // Location Information //
  @action updateLocationName(value) {
    this.location.name = value;
  }

  @action updateLocationStreetSuite(value) {
    this.location.streetSuite = value;
  }

  validateStreetSuite() {
    if (this.location.streetSuite && /^\d+$/.test(this.location.streetSuite)) {
      return true;
    }
    if (/^\W+$/.test(this.location.streetSuite)) {
      return true;
    }
    return false;
  }

  @action updateLocationCity(city) {
    this.location.city = city;
  }

  validateCity() {
    if (/^\W+$/.test(this.location.city)) {
      return true;
    }
    return false;
  }

  @action updateLocationState(state) {
    this.location.state = state;
  }

  @action updateLocationZip(zip) {
    this.location.zip = zip;
  }

  @action updateLocationContactFirst(first) {
    this.location.contactFirst = first;
  }

  @action updateLocationContactLast(last) {
    this.location.contactLast = last;
  }

  @action updateLocationContactPhone(phone) {
    this.location.contactPhoneExt = phone;
  }
  // Location Information //
  /* Practioner & Location */

  /* Incident Details */

  @action setComparator(value) {
    this.comparator = value;
  }

  @action setIncidentCategories(value) {
    this.incidentCategories = value;
  }

  @action updateIncidentRepeat(value) {
    this.incident.incidentRepeat = value;
    if (this.incident.incidentRepeat !== 'Yes') {
      this.incident.incidentEnd = '';
    }
  }

  @action setIncidentStart(value) {
    this.incident.incidentStart = value;
    if (!this.incident.incidentStart) {
      this.incident.incidentEnd = '';
    }
  }

  @action setIncidentEnd(value) {
    this.incident.incidentEnd = value;
  }

  @action setPhysOrBehavior(value) {
    this.physOrBehavior = value;
  }

  @action setMemHospitalized(value) {
    this.memHospitalized = value;
    if (this.memHospitalized !== 'Yes') {
      this.originalAdmission = '';
      this.dischargeDate = '';
      this.memReadmitted = '';
      this.readmissionDate = '';
      this.readmissDischargeDate = '';
    }
  }

  @action setOriginalAdmission(value) {
    this.originalAdmission = value;
    if (!this.originalAdmission) {
      this.dischargeDate = '';
    }
  }

  @action setDischargeDate(value) {
    this.dischargeDate = value;
  }

  @action setmemReadmitted(value) {
    this.memReadmitted = value;
    if (this.memReadmitted !== 'Yes') {
      this.readmissionDate = '';
      this.readmissDischargeDate = '';
    }
  }

  @action setReadmissionDate(value) {
    this.readmissionDate = value;
    if (!this.readmissionDate) {
      this.readmissDischargeDate = '';
    }
  }

  @action setReadmissionDischargeDate(value) {
    this.readmissDischargeDate = value;
  }


  @action updateAdditionalDetails(details) {
    this.incident.additionalDetails = details;
  }
  /* Incident Details */

  /* Review and Submit */
  @action updateEnable(id) {
    switch (id) {
      case 'editReporter':
        this.editReporter = true;
        break;
      case 'editMember':
        this.editMember = true;
        break;
      case 'editFacility':
        this.editFacility = true;
        break;
      case 'editIncident':
        this.editIncident = true;
        break;
      default:
        break;
    }
  }

  @action disableEnable(id) {
    switch (id) {
      case 'disableReporter':
        this.editReporter = false;
        break;
      case 'disableMember':
        this.editMember = false;
        break;
      case 'disableFacility':
        this.editFacility = false;
        break;
      case 'disableIncident':
        this.editIncident = false;
        break;
      default:
        break;
    }
  }

  @action disableAllEdits() {
    this.editReporter = false;
    this.editMember = false;
    this.editFacility = false;
    this.editIncident = false;
  }

  @action updateReporter(id, value) {
    switch (id) {
      case 'revRepFirst':
        this.firstName = value;
        break;
      case 'revRepLast':
        this.lastName = value;
        break;
      case 'revRepOrg':
        this.preparerOrg = value;
        break;
      case 'revRepDept':
        this.department = value;
        break;
      case 'revRepJob':
        this.jobTitle = value;
        break;
      case 'revRepPhone':
        this.repPhone = value;
        break;
      case 'revRepExt':
        this.extension = value;
        break;
      default:
        break;
    }
  }

  @action submitIncident() {
    this.incidentFormData.market = this.stateCode;
    this.incidentFormData.planName = `Healthy Blue ${this.stateCode}`;

    /* Reporter Information data */
    this.incidentFormData.submitterData.userFirstName = this.firstName;
    this.incidentFormData.submitterData.userLastName = this.lastName;
    this.incidentFormData.submitterData.dateReported = this.datetoDisplay;
    this.incidentFormData.submitterData.organization = this.reportOrg;
    this.incidentFormData.submitterData.departmentName = this.department;
    this.incidentFormData.submitterData.jobTitle = this.jobTitle;
    this.incidentFormData.submitterData.phone = `${this.repPhone}${this.extension ? `-${this.extension}` : ''}`;
    /* Reporter Information data */

    /* Member Information data */
    this.incidentFormData.member.ID = `${this.member.subscriberId.slice(3, this.member.subscriberId.length)}`;
    this.incidentFormData.member.firstName = this.member.memberFirst;
    this.incidentFormData.member.lastName = this.member.memberLast;
    this.incidentFormData.member.middleInitial = this.member.memberInitial;
    this.incidentFormData.member.dateOfBirth = this.member.memDOB ? moment(this.member.memDOB).format("MM/DD/YYYY") : "";
    this.incidentFormData.member.isMemberMinor = this.member.isMemberMinor;
    this.incidentFormData.member.parentGuardianFirstName = this.pg.pgFirstName;
    this.incidentFormData.member.parentGuardianMiddleInitial = this.pg.pgMiddleInitial;
    this.incidentFormData.member.parentGuardianLastName = this.pg.pgLastName;
    this.incidentFormData.member.parentGuardianRelation = this.pg.pgRelation;
    this.incidentFormData.member.authRepFirstName = this.authRep.authRepFirstName;
    this.incidentFormData.member.authRepMiddleInitial = this.authRep.authRepMiddleInitial;
    this.incidentFormData.member.authRepLastName = this.authRep.authRepLastName;
    this.incidentFormData.member.authRepRelation = this.authRep.authRelation;
    this.incidentFormData.member.address.addrLine1 = this.member.memStreetSuite;
    this.incidentFormData.member.address.city = this.member.memCity;
    this.incidentFormData.member.address.state = this.member.memState;
    this.incidentFormData.member.address.zip = this.member.memZip;
    this.incidentFormData.member.address.phoneNumber = this.member.memPhone;
    this.incidentFormData.member.address.phoneType = this.member.memPhoneType;
    /* Member Information data */

    /* Provider and Location data */
    this.incidentFormData.provider.name = this.location.name;
    this.incidentFormData.provider.locationContactFirstName = this.location.contactFirst;
    this.incidentFormData.provider.locationContactLastName = this.location.contactLast;
    this.incidentFormData.provider.phone = this.location.contactPhoneExt;
    this.incidentFormData.provider.address.addrLine1 = this.location.streetSuite;
    this.incidentFormData.provider.address.city = this.location.city;
    this.incidentFormData.provider.address.state = this.location.state;
    this.incidentFormData.provider.address.zip = this.location.zip;
    /* Provider and Location data */

    const practArr = [];
    practArr.push(
      {
        pracFirstName: this.practitioner.practFirst,
        pracLastName: this.practitioner.practLast,
        pracNPI: this.practitioner.pracNPI
      }
    );
    for (const pract of this.practitionerList) {
      practArr.push(
        {
          pracFirstName: pract.practFirst,
          pracLastName: pract.practLast,
          pracNPI: pract.pracNPI
        }
      )
    };
    this.incidentFormData.practitionerForQOC = practArr;

    const qArr = [];
    /* Incident Category */
    if (this.incidentCategories.includes('Procedural Issues')) {
      qArr.push(
        {
          questionID: 'Q1',       // Procedural Issues
          questionCategory: 'QOC Information',
          answerID: [
            'Q1A1'
          ]
        }
      );
    } else {
      qArr.push(
        {
          questionID: 'Q1',       // Procedural Issues
          questionCategory: 'QOC Information',
          answerID: []
        }
      );
    }
    if (this.incidentCategories.includes('Death or Serious Disability')) {
      qArr.push(
        {
          questionID: 'Q1',     // Death or Serious Disability
          questionCategory: 'QOC Information',
          answerID: [
            'Q1A2'
          ]
        }
      );
    } else {
      qArr.push(
        {
          questionID: 'Q1',     // Death or Serious Disability
          questionCategory: 'QOC Information',
          answerID: []
        }
      );
    }
    if (this.incidentCategories.includes('Delay/Omission of Care')) {
      qArr.push(
        {
          questionID: 'Q1',     // Delay/Omission of Care
          questionCategory: 'QOC Information',
          answerID: [
            'Q1A3'
          ]
        }
      );
    } else {
      qArr.push(
        {
          questionID: 'Q1',     // Delay/Omission of Care
          questionCategory: 'QOC Information',
          answerID: []
        }
      );
    }
    if (this.incidentCategories.includes('Patient Safety')) {
      qArr.push(
        {
          questionID: 'Q1',     // Patient Safety
          questionCategory: 'QOC Information',
          answerID: [
            'Q1A4'
          ]
        }
      );
    } else {
      qArr.push(
        {
          questionID: 'Q1',     // Patient Safety
          questionCategory: 'QOC Information',
          answerID: []
        }
      );
    }
    if (this.incidentCategories.includes('Post-Op Complications')) {
      qArr.push(
        {
          questionID: 'Q1',     // Post-Op Complications
          questionCategory: 'QOC Information',
          answerID: [
            'Q1A5'
          ]
        }
      );
    } else {
      qArr.push(
        {
          questionID: 'Q1',     // Post-Op Complications
          questionCategory: 'QOC Information',
          answerID: []
        }
      );
    }
    if (this.incidentCategories.includes('Quality of Service')) {
      qArr.push(
        {
          questionID: 'Q1',     // Quality of Service
          questionCategory: 'QOC Information',
          answerID: [
            'Q1A6'
          ]
        }
      );
    } else {
      qArr.push(
        {
          questionID: 'Q1',     // Quality of Service
          questionCategory: 'QOC Information',
          answerID: []
        }
      );
    }
    if (this.incidentCategories.includes('Medication Issues')) {
      qArr.push(
        {
          questionID: 'Q1',     // Medication Issues
          questionCategory: 'QOC Information',
          answerID: [
            'Q1A7'
          ]
        }
      );
    } else {
      qArr.push(
        {
          questionID: 'Q1',     // Medication Issues
          questionCategory: 'QOC Information',
          answerID: []
        }
      );
    }
    if (this.incidentCategories.includes('Financial Harm')) {
      qArr.push(
        {
          questionID: 'Q1',     // Financial Harm
          questionCategory: 'QOC Information',
          answerID: [
            'Q1A8'
          ]
        }
      );
    } else {
      qArr.push(
        {
          questionID: 'Q1',     // Financial Harm
          questionCategory: 'QOC Information',
          answerID: []
        }
      );
    }
    /* Incident Category */
    // Was this Incident related to Physical Health or Behavioral Health?
    qArr.push(
      {
        questionID: 'Q2',
        questionCategory: 'QOC Information',
        answerID: [
          `${this.physOrBehavior === 'Physical Health' ? 'Q2A1' : 'Q2A2'}`
        ]
      }
    );
    if (this.incident.incidentRepeat === 'Yes') {
      // Ongoing Occurrence Begin Date
      qArr.push(
        {
          questionID: 'Q3',
          questionCategory: 'QOC Information',
          answerID: []
        },
        {
          questionID: 'Q4',
          questionCategory: 'QOC Information',
          answerID: [
            `Q4A1-Other-${this.incident.incidentStart}`
          ]
        }
      );
    } else {
      // Single Occurrence Date
      qArr.push(
        {
          questionID: 'Q3',
          questionCategory: 'QOC Information',
          answerID: [
            `Q3A1-Other-${this.incident.incidentStart}`
          ]
        },
        {
          questionID: 'Q4',
          questionCategory: 'QOC Information',
          answerID: []
        }
      );
    }
    // Ongoing Occurrence End Date
    if (this.incident.incidentRepeat === 'Yes' && this.incident.incidentEnd) {
      qArr.push(
        {
          questionID: 'Q5',
          questionCategory: 'QOC Information',
          answerID: [
            `Q5A1-Other-${this.incident.incidentEnd}`
          ]
        }
      );
    } else {
      qArr.push(
        {
          questionID: 'Q5',
          questionCategory: 'QOC Information',
          answerID: []
        }
      );
    }
    // Has the member been hospitalized? 
    if (this.memHospitalized) {
      qArr.push(
        {
          questionID: 'Q6',
          questionCategory: 'QOC Information',
          answerID: [
            `${this.memHospitalized === 'Yes' ? 'Q6A1' : 'Q6A2'}`
          ]
        }
      );
    } else {
      qArr.push(
        {
          questionID: 'Q6',
          questionCategory: 'QOC Information',
          answerID: []
        }
      );
    }
    // Admission Date
    if (this.originalAdmission) {
      qArr.push(
        {
          questionID: 'Q7',
          questionCategory: 'QOC Information',
          answerID: [
            `Q7A1-Other-${this.originalAdmission}`
          ]
        }
      );
    } else {
      qArr.push(
        {
          questionID: 'Q7',
          questionCategory: 'QOC Information',
          answerID: []
        }
      );
    }
    // Discharge Date
    if (this.dischargeDate) {
      qArr.push(
        {
          questionID: 'Q8',
          questionCategory: 'QOC Information',
          answerID: [
            `Q8A1-Other-${this.dischargeDate}`
          ]
        }
      );
    } else {
      qArr.push(
        {
          questionID: 'Q8',
          questionCategory: 'QOC Information',
          answerID: []
        }
      );
    }
    // Has the member been readmitted within the last 30 days?
    if (this.memReadmitted) {
      qArr.push(
        {
          questionID: 'Q9',
          questionCategory: 'QOC Information',
          answerID: [
            `${this.memReadmitted === 'Yes' ? 'Q9A1' : 'Q9A2'}`
          ]
        }
      );
    } else {
      qArr.push(
        {
          questionID: 'Q9',
          questionCategory: 'QOC Information',
          answerID: []
        }
      );
    }
    // ReAdmission Date
    if (this.readmissionDate) {
      qArr.push(
        {
          questionID: 'Q10',
          questionCategory: 'QOC Information',
          answerID: [
            `Q10A1-Other-${this.readmissionDate}`
          ]
        }
      );
    } else {
      qArr.push(
        {
          questionID: 'Q10',
          questionCategory: 'QOC Information',
          answerID: []
        }
      );
    }
    // ReDischarge Date
    if (this.readmissDischargeDate) {
      qArr.push(
        {
          questionID: 'Q11',
          questionCategory: 'QOC Information',
          answerID: [
            `Q11A1-Other-${this.readmissDischargeDate}`
          ]
        }
      );
    } else {
      qArr.push(
        {
          questionID: 'Q11',
          questionCategory: 'QOC Information',
          answerID: []
        }
      );
    }
    // What is the Description of Event? 
    qArr.push(
      {
        questionID: 'Q12',
        questionCategory: 'QOC Information',
        answerID: [
          `Q12A1-Other-${this.incident.additionalDetails}`
        ]
      },
      {
        // Did the incident of harm occur more than once?
        questionID: 'Q13',
        questionCategory: 'Internal Use',
        answerID: [
          `${this.incident.incidentRepeat === 'Yes' ? 'Q13A1' : 'Q13A2'}`
        ]
      }
    );
    this.incidentFormData.questions = qArr;
    return this.incidentFormData;
  }

  @action turnOnBlocking() {
    this.blocking = true;
  }

  @action turnOffBlocking() {
    this.blocking = false;
  }

}

export default new QualityStore();